/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './file-upload-button.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/components/file-upload-button/file-upload-button.component';
import * as i3 from '../../../../../app/core/services/common-api.service';
import * as i4 from 'ng2-json-editor/src/shared/services/json-store.service';
import * as i5 from 'ngx-toastr';
const styles_FileUploadButtonComponent:any[] = [i0.styles];
export const RenderType_FileUploadButtonComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_FileUploadButtonComponent,data:{}});
export function View_FileUploadButtonComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵeld(0,0,[['uploader',1]],(null as any),0,'input',[['accept',
      'application/pdf'],['type','file']],[[4,'display',(null as any)]],[[(null as any),
      'change']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.FileUploadButtonComponent = _v.component;
    if (('change' === en)) {
      const pd_0:any = ((<any>_co.onFileSelect($event.target.files[0])) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),1,'button',[['type','button']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,0).click()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Upload']))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = 'none';
        _ck(_v,0,0,currVal_0);
      });
}
export function View_FileUploadButtonComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-file-upload-button',
      ([] as any[]),(null as any),(null as any),(null as any),View_FileUploadButtonComponent_0,
      RenderType_FileUploadButtonComponent)),i1.ɵdid(1,49152,(null as any),0,i2.FileUploadButtonComponent,
      [i3.CommonApiService,i4.JsonStoreService,i5.ToastrService],(null as any),(null as any))],
      (null as any),(null as any));
}
export const FileUploadButtonComponentNgFactory:i1.ComponentFactory<i2.FileUploadButtonComponent> = i1.ɵccf('re-file-upload-button',
    i2.FileUploadButtonComponent,View_FileUploadButtonComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2ZpbGUtdXBsb2FkLWJ1dHRvbi9maWxlLXVwbG9hZC1idXR0b24uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2ZpbGUtdXBsb2FkLWJ1dHRvbi9maWxlLXVwbG9hZC1idXR0b24uY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvaW5zcGlyZWhlcC9yZWNvcmQtZWRpdG9yL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvZmlsZS11cGxvYWQtYnV0dG9uL2ZpbGUtdXBsb2FkLWJ1dHRvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2ZpbGUtdXBsb2FkLWJ1dHRvbi9maWxlLXVwbG9hZC1idXR0b24uY29tcG9uZW50LnRzLkZpbGVVcGxvYWRCdXR0b25Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8aW5wdXQgI3VwbG9hZGVyIHR5cGU9XCJmaWxlXCIgKGNoYW5nZSk9XCJvbkZpbGVTZWxlY3QoJGV2ZW50LnRhcmdldC5maWxlc1swXSlcIiBhY2NlcHQ9XCJhcHBsaWNhdGlvbi9wZGZcIiBbc3R5bGUuZGlzcGxheV09XCInbm9uZSdcIj5cbjxidXR0b24gdHlwZT1cImJ1dHRvblwiIChjbGljayk9XCJ1cGxvYWRlci5jbGljaygpXCI+VXBsb2FkPC9idXR0b24+IiwiPHJlLWZpbGUtdXBsb2FkLWJ1dHRvbj48L3JlLWZpbGUtdXBsb2FkLWJ1dHRvbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUE2QjtNQUFBO01BQUE7SUFBQTtJQUE3QjtFQUFBLGdDQUErSCwwQ0FDL0g7YUFBQTtVQUFBO1lBQUE7WUFBc0I7Y0FBQTtjQUFBO1lBQUE7WUFBdEI7VUFBQSxnQ0FBaUQ7O1FBRHFEO1FBQXRHLFdBQXNHLFNBQXRHOzs7O29CQ0FBO01BQUE7MENBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/file-upload-button/file-upload-button.component.ngfactory.ts